<template>
  <f7-list-item ref="accordionItem" accordion-item :title="question.title" :accordion-item-opened="focus">
    <span slot="after" :style="{ color: question.value ? 'gray' : 'red' }">{{ question.selectedOption ? question.selectedOption.toString() : '請選擇' }}</span>
    <f7-accordion-content>
      <f7-list style="margin-left: 20px;">
        <f7-list-item
          v-for="(option, i) in question.options"
          :key="`radio-${question.id}-${i}`"
          radio
          :title="option.toString()"
          :checked="option.id === question.value"
          @click="selectOption(option.id)" />
      </f7-list>
    </f7-accordion-content>
  </f7-list-item>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Question from './Question'
import bowser from 'bowser'

export default {
  name: 'RadioQuestion',
  dependencies: ['CartElementBuilder'],
  beforeCreate () {
    this.$options.components.Question = Question
  },
  mounted () {
    this.onFocus()
  },
  props: {
    itemObj: Object,
    questionId: {},
    focus: Boolean
  },
  watch: {
    focus (focus) {
      this.onFocus()
    }
  },
  computed: {
    ...mapGetters(['storeId', 'currentMenu']),
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionId, this.itemObj, this.currentMenu)
    },
    subQuestions () {
      return this.question.selectedOption ? this.question.selectedOption.questions : []
    },
    questionUrl () {
      return `/stores/${this.storeId}/items/${this.itemObj.itemBucket}/${this.itemObj.id}.${this.itemObj.instanceId}/questions/${this.questionId}/radio-actions`
    }
  },
  methods: {
    ...mapActions('itemModule', ['setQuestion']),
    showActions () {
      this.$f7router.navigate(this.questionUrl)
    },
    selectOption (oid) {
      this.$f7.accordion.close(this.$refs.accordionItem.$el)
      this.setQuestion({
        itemBucket: this.itemObj.itemBucket,
        itemId: this.itemObj.id,
        itemInstanceId: this.itemObj.instanceId,
        questionId: this.questionId,
        value: oid
      })
    },
    onFocus () {
      if (this.focus) {
        const ua = bowser._detect ? bowser._detect(navigator.userAgent) : bowser

        // iOS 會出問題，所以把 iOS scroll 功能拿掉
        if (!(ua && ua.ios && ua.safari && parseInt(ua.osversion, 10) === 12)) {
          setTimeout(() => {
            this.$refs.accordionItem.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 1000) // accordion 收起來要 0.3 秒
        }
      }
    }
  }
}
</script>
